import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Image } from "semantic-ui-react";
import eyeImg from "./assets/images/inclusive-eye.svg";
import InclusivePanel from "./components/inclusive/InclusivePanel";

export default function Menu({
  isOpenInclusive,
  setIsOpenInclusive,
  setIsStickyInclusive,
  isStickyInclusive,
}) {
  return (
    <div>
      {isOpenInclusive && (
        <InclusivePanel
          isOpenInclusive={isOpenInclusive}
          setIsStickyInclusive={setIsStickyInclusive}
          setIsOpenInclusive={setIsOpenInclusive}
          isStickyInclusive={isStickyInclusive}
        />
      )}
      <nav style={{ position: "relative" }}>
        <input type="checkbox" id="hmt" className="hidden-menu-ticker" />
        <label className="btn-menu" htmlFor="hmt">
          <span className="first"></span>
          <span className="second"></span>
          <span className="third"></span>
        </label>
        <div id="mobile_patern"></div>
        <div className="first-block-nav-logo">
          <Link to="/">
            <Image
              src="images/dg_logo.svg"
              alt="dg_logo"
              className="image-logo-first"
            />
          </Link>
        </div>

        <div className="menu hidden-menu" id="mobilenav" tabIndex="1">
          <div className="first-block-nav-links">
            <ul>
              <li>
                <a href="https://sgroshi.com.ua/ua/reverse-form/">
                  Зворотній зв'язок
                </a>
              </li>
              <li>
                <a href="https://sgroshi.com.ua/ua/reverse-form/">
                  Написати скаргу
                </a>
              </li>
              <li>
                <a href="https://sgroshi.com.ua/ua/oplatyty-kredyt/">
                  Оплатити
                </a>
              </li>
              <li>
                <a href="https://sgroshi.com.ua/ua/contacts/">Відділення</a>
              </li>
            </ul>
          </div>
          <button
            id="web_eye_togler"
            className="inclusive-menu-toggler"
            title="Людям із порушенням зору"
            aria-label="Відкрити панель інклюзивності"
            onClick={() => setIsOpenInclusive(!isOpenInclusive)}
          >
            <Image src={eyeImg} alt="inclusive-icon" data-not-hide-image />
            <span>Людям з порушенням зору</span>
          </button>
          <div className="first-block-nav-contact">
            <a className="phone-number" href="tel:+380735601050">
              +38 073 560 10 50
            </a>
          </div>
        </div>
        <div className="first-block-nav-lk-button">
          <button
            className="lk-btn"
            onClick={(e) =>
              (window.location.href = `https://sgroshi.com.ua/ua?partner=dovghoghroshi&subpartner=1&utm_source=dovghoghroshi&utm_medium=vitrina&utm_term=1&utm_content=1&utm_campaign=1`)
            }
          >
            {" "}
            Увійти{" "}
          </button>
        </div>
      </nav>
    </div>
  );
}



// WEBPACK FOOTER //
// src/Menu.js